(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/slide-indicator.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/slide-indicator.js');
"use strict";

const {
  useMemo
} = React;
const {
  NavigationIndicator,
  NavigationIndicatorDot,
  NavigationIndicatorPrev,
  NavigationIndicatorNext
} = svs.ui.ReactNavigationIndicator;
const SlideIndicator = _ref => {
  let {
    totalCount,
    activeSlide,
    setActiveSlide,
    isNextDisalbed,
    nextSlide,
    isPrevDisalbed,
    prevSlide,
    branding
  } = _ref;
  const dotsArr = useMemo(() => {
    const dots = new Array(totalCount).fill(null);
    return dots.map((_, index) => {
      const dotIndex = index;
      return React.createElement(NavigationIndicatorDot, {
        isActive: activeSlide === dotIndex,
        key: dotIndex,
        onClick: () => {
          setActiveSlide(dotIndex);
        }
      });
    });
  }, [totalCount, activeSlide, setActiveSlide]);
  return React.createElement(NavigationIndicator, {
    branding: branding
  }, React.createElement(NavigationIndicatorPrev, {
    branding: branding,
    disabled: isPrevDisalbed,
    onClick: prevSlide
  }), dotsArr, React.createElement(NavigationIndicatorNext, {
    branding: branding,
    disabled: isNextDisalbed,
    onClick: nextSlide
  }));
};
setGlobal('svs.components.onboarding.slides.SlideIndicator', SlideIndicator);

 })(window);